/* tslint:disable */
import { PosRiskAction } from './posrisk.action';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { share, map, catchError, mergeMap, withLatestFrom, debounceTime, switchMap, tap } from 'rxjs/operators';
import { BackendService } from '../../services/backend/backend.service';
import { AppState } from '../../interfaces/app-state.interface';
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { RoutesTable } from '../../resources/routes-table.model';
import { CustodyClientOrder } from '../../models/custody/custody-client-order.model';
import { UtilitiesService } from '../../services/utilities.service';

@Injectable()
export class PosRiskEffects {

    constructor(
        private store$: Store<AppState>,
        private actions$: Actions<PosRiskAction>,
        private dataService: BackendService,
        private utilitiesService: UtilitiesService
    ) {}

    /**
     * Recupera o stress de um instrumento e se ele é pTax
     */
    public getStress$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PosRiskAction.getStress),
            withLatestFrom(
                this.store$.select((store) => store.posrisk)
            ),
            mergeMap(([action, posRiskState]) => {

                const normalizedSymbol = action.payload.symbol.toUpperCase();

                const url = RoutesTable.composeUri(
                    RoutesTable.posRisk.routes.getOneStress,
                    action.payload.symbol,
                    action.payload.isStrategy,
                    action.payload.isDayTrade
                );

                // Request pendente
                if (posRiskState.pendingStressRequests.find((requestURL) => requestURL === url)) {
                    return of(
                        {
                            type: PosRiskAction.gettingStress,
                            payload: {
                                hash: url,
                            },
                        },
                    );
                }

                // Buscando stress
                this.store$.dispatch({
                    type: PosRiskAction.gettingStress,
                    payload: {
                        hash: url
                    }
                });

                // Checking on server
                return this.dataService
                    .get<DefaultResponse>(url)
                    .pipe(
                        map((result) => {

                            if (!result.ok) {
                                return {
                                    type: PosRiskAction.getStressError,
                                    payload: {
                                        error: result.messages,
                                        hash: url
                                    }
                                };
                            }

                            return this.getAction(
                                normalizedSymbol,
                                action.payload.isDayTrade,
                                action.payload.isStrategy,
                                result.value,
                                url
                            );
                        }),
                        catchError((error) => of({
                            type: PosRiskAction.getStressError,
                            payload: {
                                error,
                                hash: url
                            }
                        })),
                    );
            }),
            share(),
        )
    );

    public getClientCustodies$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PosRiskAction.getClientCustodies),
            debounceTime(500),
            switchMap(() => {
                return this.dataService
                .get(RoutesTable.posRisk.routes.getCustodyClient.uri)
                .pipe(
                    map((result: any) => {

                        if (result.ok) {
                            const stocks = result.value.stocks.map((item) => new CustodyClientOrder(
                                item.assetCode, item.total, this.utilitiesService.guid(), false, item.averagePrice, item.ordersAmountInvested,
                            ));

                            const futures = result.value.futures.map((item) => new CustodyClientOrder(
                                item.assetCode, item.total, this.utilitiesService.guid(), false, item.averagePrice, item.ordersAmountInvested,
                            ));

                            const stocksDT = result.value.stocksDTs.map((item) => new CustodyClientOrder(
                                item.assetCode, item.total, this.utilitiesService.guid(), true, item.averagePrice, item.ordersAmountInvested,
                            ));

                            const futuresDT = result.value.futuresDT.map((item) => new CustodyClientOrder(
                                item.assetCode, item.total, this.utilitiesService.guid(), true, item.averagePrice, item.ordersAmountInvested,
                            ));

                            const options = result.value.options.map((item) => new CustodyClientOrder(
                                item.assetCode, item.total, this.utilitiesService.guid(), false, item.averagePrice, item.ordersAmountInvested,
                            ));

                            return {
                                type: PosRiskAction.getClientCustodiesSuccess,
                                payload: stocks.concat(futures, stocksDT, futuresDT, options)
                            };
                        }

                        return {
                            type: PosRiskAction.getClientCustodiesError,
                            payload: result.value
                        };

                    }),
                    catchError((error) => of({
                        type: PosRiskAction.getStressError,
                        payload: error
                    })),
                );
            }),
            share(),

        )
    );

    public clientCustodiesLoaded$ = createEffect(
        () => this.actions$.pipe(
            ofType(PosRiskAction.getClientCustodiesSuccess),
            share()
        ),
        { dispatch: false }
    );

     /**
     * ??
     */
    public getClientRiskModel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PosRiskAction.getClientRiskModel),
            switchMap(() => {
                return this.dataService
                .get(RoutesTable.posRisk.routes.getRiskModel.uri)
                .pipe(
                    map((result: any) => {

                        if (!result.ok) {
                            return {
                                type: PosRiskAction.getClientRiskModelError,
                                payload: null
                            };
                        }

                        return {
                            type: PosRiskAction.getClientRiskModelSuccess,
                            payload: result.value
                        };

                    }),
                    catchError((error) => of(
                        {
                            type: PosRiskAction.getClientRiskModelError,
                            payload: error
                        }
                    )),
                );
            }),
            share(),
        )
    );

    /**
     * ??
     */
    public setClientRiskModel$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PosRiskAction.setClientRiskModel),
            switchMap((action: any) => {
                return this.dataService
                .post(
                    RoutesTable.posRisk.routes.getRiskModel.uri,
                    action.payload,
                    action.token
                )
                .pipe(
                    map((result: any) => {

                        if (!result.ok) {
                            return {
                                type: PosRiskAction.setClientRiskModelError,
                                payload: null
                            };
                        }

                        return {
                            type: PosRiskAction.setClientRiskModelSuccess,
                            payload: result.value
                        };

                    }),
                    catchError((error) => of(
                        {
                            type: PosRiskAction.setClientRiskModelError,
                            payload: error
                        }
                    )),
                );
            }),
            share(),
        )
    );

    /**
     * setar bloqueio ou desbloqueio pos-risco cadastro
     */
    public setAccountPermission$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PosRiskAction.setAccountPermission),
            switchMap((action: any) => {
                return this.dataService
                .post(
                    RoutesTable.posRisk.routes.setAccountPermission.uri,
                    action.payload
                )
                .pipe(
                    map((result: any) => {

                        if (!result.ok) {
                            return {
                                type: PosRiskAction.setAccountPermissionError,
                                payload: new Error(result.messsages[0].message),
                            };
                        }

                        return {
                            type: PosRiskAction.setAccountPermissionSuccess,
                            payload: result.value
                        };

                    }),
                    catchError((error) => of(
                        {
                            type: PosRiskAction.setAccountPermissionError,
                            payload: error
                        }
                    )),
                );
            }),
            share(),
        )
    );

    /** Compõe uma action baseando-se nas definições de busca do stress
     * @param symbol símbolo
     * @param isDayTrade é dayTrade
     * @param isStrategy é estratégia
     * @param result request result
     * @param url url do recurso
     */
    private getAction(symbol: string, isDayTrade: boolean, isStrategy: boolean, result: any, url: string ) {

        const payload = {
            data: result,
            code: symbol,
            hash: url
        };

        // Estratégia
        if (isStrategy) {
            return {
                type: PosRiskAction.getStrategyStressSuccess,
                payload
            };
        }

        // Daytrade e swing trade

        const type = isDayTrade ? PosRiskAction.getDayTradeStressSuccess : PosRiskAction.getDefaultStressSuccess;

        return {
            type,
            payload
        };
    }
}